import { createFileRoute, isRedirect, redirect } from "@tanstack/react-router"

import { AuthenticationService, type UserPublic } from "@/client"
import { getDefaultRouteForRole } from "@/hooks/useAuth"

export const Route = createFileRoute("/_layout/")({
  beforeLoad: async () => {
    try {
      const user = await AuthenticationService.getCurrentUserInfo()
      const route = getDefaultRouteForRole(user as UserPublic)
      throw redirect({ to: route })
    } catch (e) {
      if (isRedirect(e)) throw e
      // Fallback: if fetching user fails, go to dashboard
      throw redirect({ to: "/dashboard" })
    }
  },
})
